/**
 * 功能: 录入更新日志的弹框组件
 */
<template lang="pug">
  div.brief-log
    el-dialog.clearfix(title="修改日志" :visible.sync="isShow" width="70%" @close="handleClose")
      el-form(ref="formData" label-width="80px" :model="form" :size="GLOBAL.SIZE_OF_INPUTBOX"  :rules="briefLogRules")
        el-row
          el-col(:span="6")
            el-form-item(label="作者" prop="author")
              el-input(v-model="form.author")
          el-col(:span="10")
            el-form-item(label="发布日期" prop="pubDate")
              el-date-picker(
                v-model="form.pubDate"
                type="date"
                placeholder="选择日期")
          el-col(:span="6")
            el-form-item(label="是否公开")
              el-checkbox(v-model="form.publicity")
        el-row
          el-col(:span="24")
            el-form-item(label="公开描述")
              el-input(type="textarea" :rows="5" v-model="form.description")
        el-row
          el-col(:span="24" style="text-align: center")
            el-upload.upload-demo(
              drag
              :action="GLOBAL.uploadHost + 'brief/uploadLog'"
              :headers="headers"
              :on-success="handleUploadLog"
              :file-list="fileList"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              :on-error="handleUploadErr")
              i.el-icon-upload
              div.el-upload__text 将文件拖到此处，或
                em 点击上传
        el-row
          el-col(:span="24" style="margin-top:20px")
            el-button.fr(type="primary" @click="handleInsert" :disabled="iCanUpload || isSave" :size="GLOBAL.SIZE_OF_INPUTBOX" style="margin-right:10px") 保存
</template>

<script>
import passport from '@/javascripts/passport'
export default {
  name: 'LogDialog',
  data () {
    return {
      briefLogRules: {
        author: { required: true, message: '请输入作者名称', trigger: 'blur' },
        pubDate: { required: true, message: '请选择发布日期', trigger: 'blur' }
      },
      isShow: false,
      form: { },
      headers: passport.headers(),
      fileList: [],
      iCanUpload: false,
      isSave: false
    }
  },
  methods: {
    // 初始化数据弹框
    show (data) {
      this.isShow = true
      this.form = data
      if (localStorage.status && localStorage.status >= 1) {
        this.isSave = true
      }
      if (this.form.originalFile) {
        this.fileList = [{ name: this.form.originalFile }]
      }
    },
    // 上传附件
    handleUploadLog (response, file, fileList) {
      this.$message({ type: 'success', message: '上传附件成功！' })
      this.iCanUpload = false
      this.form.originalFile = response.data
    },
    // 上传之前 设置 iCanUpload
    handleBeforeUpload () {
      this.iCanUpload = true
    },
    // 上传附件失败
    handleUploadErr () {
      this.iCanUpload = false
      this.$message({ type: 'error', message: '上传附件失败！上传超时' })
    },
    // 插入数据
    handleInsert () {
      this.$emit('update', this.form)
    },
    // 移除附件
    handleRemove (file, fileList) {
      this.form.originalFile = ''
      this.fileList = []
    },
    // 关闭弹框
    handleClose () {
      this.form = { }
      this.fileList = []
    }
  },
  filters: {
    formatTime (val) {
      if (val) {
        return val.slice(0, 10)
      } else {
        return null
      }
    }
  }
}
</script>

<style>

</style>
